app.bind('default layer', function(context){
    $('[js-overlayer]', context).layer({
        isOverlayer: true,
        beforeOpen: ($layer, payload = {}) => {
            app.use('basic', $layer);
        },
        afterOpen: ($layer, payload = {}) => {},
        afterClose: ($layer, payload = {}) => {}
    });

    $('[js-layer]', context).layer({
        beforeOpen: ($layer, layerData) => {
            app.use('basic', $layer);
        },
        afterOpen: ($layer, layerData) => {},
        afterClose: ($layer, layerData) => {}
    });

    $('[js-overlayer-lock]', context).layer({
        isOverlayer: true,
        disableOverlayClose: true,
        beforeOpen: ($layer, layerData) => {
            app.use('basic', $layer);
        },
        afterOpen: ($layer, layerData) => {},
        afterClose: ($layer, layerData) => {}
    });
});
